import { auth, db } from '../firebase/firebase'
import { authLoaded, authLoading, authLogin, authLogout } from '../reducer/AuthReducer'
import { fraseLogout } from '../reducer/FraseDelDiaReducer'
import { logoutPerfil, startLoadingPerfil } from '../reducer/PerfilReducer'
import { logoutAsig } from '../reducer/AsignaturasReducer'
import { logoutthemes } from '../reducer/TemasReducer'
import { logoutcontenido } from '../reducer/ContenidoReducer'



export const startRegisterWithEmailPasswordName = (email, password, name) => {
    return (dispatch) => {
        auth.createUserWithEmailAndPassword(email, password)
            .then(async ({ user }) => {
                await user.updateProfile({ displayName: name });
                await db.collection('usuariosW').doc(user.email).set({
                    date: Date.now(),
                    description: 'Aun no he hecho mi descripción',
                    displayName: name,
                    email: user.email,
                    faculty: '',
                    photoURL: 'https://w7.pngwing.com/pngs/81/570/png-transparent-profile-logo-computer-icons-user-user-blue-heroes-logo-thumbnail.png',
                    program: '',
                    rol: 'docente',
                    state: false,
                    subjects: 'Aun no he agregado mis asignaturas',
                    uid: user.uid,
                    gender: ''
                })
                dispatch(authLoading())
                dispatch(authLogin())
                dispatch(startLoadingPerfil(user.uid))
                dispatch(authLoaded())
            }).catch(e => {
                console.log(e);
            })
    }
}




export const startLoginEmailAndPassword = (email, password) => {
    return auth.signInWithEmailAndPassword(email,password)
}


export const startLoginEmailPassword = (user) => {
    return (dispatch) => {
        dispatch(authLoading());
        dispatch(authLogin());
        dispatch(startLoadingPerfil(user.user.uid))
        dispatch(authLoaded());
    }
}


export const startLogout = () => {
    return async (dispatch) => {
        await auth.signOut();
        dispatch(authLogout())
        dispatch(logoutPerfil())
        dispatch(fraseLogout())
        dispatch(logoutAsig())
        dispatch(logoutthemes())
        dispatch(logoutcontenido())
    }
}
